import { render, staticRenderFns } from "./ItemEsposa.vue?vue&type=template&id=4287c274"
import script from "./ItemEsposa.vue?vue&type=script&setup=true&lang=ts"
export * from "./ItemEsposa.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports